import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Screener_settings from "./Components/Screener_Setting";
import StockTable from "./Components/Table";
import SortAndFilterStocks from "./Components/Sorting";
import LoadingScreen from "./Components/Loader"
import Header from "../Homepage/Components/Header"
import { Helmet } from "react-helmet-async";

function Screener() {
    const [stockInfo, setStockInfo] = useState([]);
    const [filteredAndSortedStocks, setFilteredAndSortedStocks] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // Loading bar state

    // State for selected sorting criterion
    const [selectedSortCriterion, setSelectedSortCriterion] = useState("marketCap");

    // State for filters
    const [filters, setFilters] = useState({
        strongBuy: "",
        buy: "",
        volume: "",
        newsKeyword: "",
        undervalued: false,
        rank: "",
    });

    // State for selected indicators
    const [selectedIndicators, setSelectedIndicators] = useState({
        hourly: [],
        daily: [],
    });

    // Handle sort change
    const handleSortChange = (newSort) => {
        setSelectedSortCriterion(newSort);
    };

    // Handle filter change
    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
    };

    // Handle indicator change
    const handleIndicatorChange = (interval, indicators) => {
        setSelectedIndicators((prev) => ({
            ...prev,
            [interval]: indicators,
        }));
    };

    // Fetch stock data
    useEffect(() => {
        fetchBestPerformingStocks('https://my-market-data-bucket.s3.ap-southeast-2.amazonaws.com/market_data_US.json'); // Initial fetch
    }, []);

    const fetchBestPerformingStocks = (url) => {
        setIsLoading(true); // Start loading
        axios
            .get(url)
            .then(response => {
                if (response.data) {
                    setStockInfo(response.data.stock_info);
                }
            })
            .catch(error => {
                console.error('There was an error fetching the stocks!', error);
            })
            .finally(() => {
                setIsLoading(false); // End loading
            });
    };

    return (
        <div>
                            <Helmet>
                    <title>Stock101 Screener</title>
                    <meta name="description" content="Welcome to stock 101 Screener, Our Powerful screener allows users to sort and filter NYSE stocks in various ways, Market Capatalization, Call Options, Undervalues 
                    Stocks, Analyst Recommendations, Stock News, Search Stock News, Point based sporting based on technical indicators " />
                    <meta name="keywords" content="NYSE, Stock Market, Option Based Filter,Zacks Rankings, Prize Targets, Trending News, Technical Indicators, Undervalued Stocks, Call Option Volume, Put Option Value" />
                    <meta name="robots" content="index, follow" /> 
                  </Helmet>
            <Header/>
            <Screener_settings
                onSortChange={handleSortChange}
                onFilterChange={handleFilterChange}
                onIndicatorChange={handleIndicatorChange}
            />


<SortAndFilterStocks
  stockInfo={stockInfo}
  sortCriterion={selectedSortCriterion}
  filters={filters}
  selectedIndicators={selectedIndicators}
  onProcessingComplete={setFilteredAndSortedStocks}
  onLoadingChange={setIsLoading} // Pass the function to update loading state
/>
          

<div>
    {isLoading ? (
        <LoadingScreen />
    ) : (
        <StockTable stockInfo={filteredAndSortedStocks} />
    )}
</div>
        </div>
    );
}

export default Screener;
